import { MdOutlineRemoveCircle } from 'react-icons/md';
import { useCityContext } from '../../../contexts/CityProvider';

const SelectedCitiesTable = () => {
  // integration of context hooks here
  const { selectedCities, setSelectedCities } = useCityContext();

  // rendering selected cities table component here
  return (
    <div className='border-2 border-dashed border-legal-dark-blue rounded-lg'>
      <div className='grid grid-cols-[1fr_1fr_50px] text-center border-b-2 border-dashed border-legal-dark-blue text-legal-dark-blue font-semibold [&>p]:py-2 [&>p:not(:last-child)]:border-r [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-legal-dark-blue'>
        <p>Province</p>
        <p>City</p>
        <p></p>
      </div>

      <div className='[&>div:not(:last-child)]:border-b [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-legal-dark-blue'>
        {selectedCities.map((city, index) => (
          <div
            key={index}
            className='grid grid-cols-[1fr_1fr_50px] text-center text-legal-dark-blue [&>p]:py-2 [&>p:not(:last-child)]:border-r [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-legal-dark-blue'
          >
            <p title={city.province_name} className='w-full truncate px-1'>
              {city.province_name}
            </p>
            <p>{city.city_name}</p>

            <div className='flex items-center justify-center'>
              <button
                type='button'
                onClick={() =>
                  setSelectedCities((state) =>
                    state.filter(
                      (existingCity) =>
                        existingCity.city_name !== city.city_name
                    )
                  )
                }
                className='rounded-full'
              >
                <MdOutlineRemoveCircle className='size-5 text-base-red hover:opacity-70 duration-300' />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectedCitiesTable;
